var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as React from "react";
import { connect } from "react-redux";
import { IdResource } from "../../../constants/IdResource";
import { IdStyles } from "../../../less/IdStyles";
import { selectActiveExpansionCostBuff } from "../../../selectors/selectBuffsInfo";
import { selectActiveDiscountEventInfoByEventType } from "../../../selectors/selectEventInfo";
import { selectExpansionBuyCost, selectExpansionInfo, } from "../../../selectors/selectExpansionInfo";
import { IdLoca } from "../../../utils/i18n/IdLoca";
import { utilBuff } from "../../../utils/utilBuff";
import { utilEvent } from "../../../utils/utilEvent";
import { EventType } from "../../balancing/types/BalancingCore";
import { DialogWrapper } from "../../dialog/DialogWrapper";
import { DiscountEventTimer } from "../../discount-event/DiscountEventTimer";
import { Badge } from "../../generic/badge/Badge";
import { IdBadgePosition } from "../../generic/badge/IdBadgePosition";
import { componentWithProps } from "../../generic/componentWithProps";
import { ResourceBar } from "../../generic/resource-bar/ResourceBar";
import { actionModalClose } from "../../modals/actionModal";
import { IdModal } from "../../modals/IdModal";
import { actionExpansionBuyPremium, actionExpansionBuyStandard, actionExpansionsDeselect, } from "./actionExpansions";
import { PremiumPurchaseBuyExpansions } from "./PremiumPurchaseBuyExpansions";
import { StandardPurchaseBuyExpansions } from "./StandardPurchaseBuyExpansions";
var _MenuExpansionsPurchase = function (_a) {
    var onClose = _a.onClose, onPremiumBuy = _a.onPremiumBuy, onStandardBuy = _a.onStandardBuy, expansionId = _a.expansionId, expansionCostInfo = _a.expansionCostInfo, expansionDiscountEvent = _a.expansionDiscountEvent, expansionDiscountPremiumBuff = _a.expansionDiscountPremiumBuff, expansionDiscountStandardBuff = _a.expansionDiscountStandardBuff, expansionInfo = _a.expansionInfo;
    var standard = expansionCostInfo.standard, premium = expansionCostInfo.premium;
    var _b = expansionInfo.baseSetup, expansionsSizeX = _b.expansionsSizeX, expansionsSizeY = _b.expansionsSizeY;
    var footerResources = [IdResource.Money, IdResource.Gold];
    var footerComponent = componentWithProps({
        ComponentType: ResourceBar,
        resources: footerResources,
    });
    var discountBadge;
    if (expansionDiscountPremiumBuff && expansionDiscountEvent) {
        var discountEndTime = utilEvent.getEndTime(expansionDiscountEvent);
        var discountPercentage = utilBuff.factorMultiplicationToPercentage(expansionDiscountPremiumBuff.factorMultiplication);
        discountBadge = (React.createElement(Badge, { position: IdBadgePosition.TopLeft },
            React.createElement(DiscountEventTimer, { discountAmount: discountPercentage, endTime: discountEndTime })));
    }
    return (React.createElement(DialogWrapper, { titleLocaId: IdLoca.expansionDialog_title, onClose: onClose, className: IdStyles.ModalBackgroundBuyExpansion, footerRenderer: footerComponent },
        discountBadge,
        React.createElement("div", { className: "expansion-menu" },
            React.createElement(PremiumPurchaseBuyExpansions, { expansionDiscountBuff: expansionDiscountPremiumBuff, onBuyExpansion: function (amount) { return onPremiumBuy(expansionId, amount); }, expansionsSizeX: expansionsSizeX, expansionsSizeY: expansionsSizeY, expansionTypeInfo: premium }),
            React.createElement(StandardPurchaseBuyExpansions, { expansionDiscountBuff: expansionDiscountStandardBuff, expansionTypeInfo: standard, expansionsSizeX: expansionsSizeX, expansionsSizeY: expansionsSizeY, onBuyExpansion: function (missingResources, missingAmount) {
                    return onStandardBuy(expansionId, missingResources, missingAmount);
                } }))));
};
var mapState = function (state) { return (__assign({}, state.playerBase.expansions, { expansionCostInfo: selectExpansionBuyCost(state), expansionDiscountEvent: selectActiveDiscountEventInfoByEventType(state, EventType.ExpansionDiscount), expansionDiscountPremiumBuff: selectActiveExpansionCostBuff(state, IdResource.Gold), expansionDiscountStandardBuff: selectActiveExpansionCostBuff(state, IdResource.Money), expansionInfo: selectExpansionInfo(state) })); };
var mapDispatch = function (dispatch) { return ({
    onClose: function () {
        dispatch(actionModalClose(IdModal.PurchaseExpansion));
        dispatch(actionExpansionsDeselect());
    },
    onPremiumBuy: function (expansionId, premiumAmount) {
        return dispatch(actionExpansionBuyPremium(expansionId, premiumAmount));
    },
    onStandardBuy: function (expansionId, missingResources, notEnoughDollar) { return dispatch(actionExpansionBuyStandard(expansionId, missingResources, notEnoughDollar)); },
}); };
export var MenuExpansionsPurchase = connect(mapState, mapDispatch)(_MenuExpansionsPurchase);



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/expansions/MenuExpansionsPurchase.tsx
// module id = 2865
// module chunks = 3